module.exports = __webpack_public_path__ + "static/img/i148.3293c1c4.png";